import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

import { formatDate } from '@usas/ui-web/utils/DateFunctions';

const GridRow = ({ member, onSelectClicked, onShowRenewalConfirmationModalClicked }) => {
  return (
    <tr key={'personId' + member.personId + 'offeringInstanceId' + member.offeringInstanceId}>
      <td>{(member.firstName || member.middleName || member.lastName) ? `${member.firstName || ''}  ${member.preferredName !== '' && member.preferredName !== member.firstName ? '"' + member.preferredName + '"' : ''} ${member.middleName || ''} ${member.lastName || ''}` : ''}</td>
      <td>{member.competitionGenderTypeDisplayName || ''}</td>
      <td>{member.birthDate ? formatDate(member.birthDate) : ''}</td>
      <td><span className='pull-right'>{member.provideAdditionalInformation === true ? <ActionIntraPageButton onClick={(e) => onShowRenewalConfirmationModalClicked(e, member)}>Update Information & Register</ActionIntraPageButton> : <ActionIntraPageButton onClick={(e) => onSelectClicked(e, member)}>Add / Upgrade Memberships</ActionIntraPageButton>}</span></td>
    </tr>
  );
};

const MyFamilyMembersLargeGrid = ({ gridData, isLoading, onSelectClicked, onShowRenewalConfirmationModalClicked }) => (
  <table className={[global.UsasTable, 'visible-md visible-lg'].join(' ')}>
    <thead>
      <tr>
        <th>Name</th>
        <th style={{ minWidth: '120px' }}>Comp. Category</th>
        <th>Birth Date</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      {isLoading === true ?
        <tr><td colSpan={"4"}>Loading...</td></tr>
        : Array.isArray(gridData) && gridData.length > 0 ?
          gridData.map((member, i) =>
            <GridRow
              key={i}
              member={member}
              onSelectClicked={onSelectClicked}
              onShowRenewalConfirmationModalClicked={onShowRenewalConfirmationModalClicked}
            />)
          :
          <tr>
            <td colSpan={"4"}>No Family Members are Associated with this Account</td>
          </tr>
      }
    </tbody>
  </table>
);

export default MyFamilyMembersLargeGrid;